"use strict";

import angular from "angular";
/**
 * @component NuDataComparationValue
 * O <nu-data-comparation-value> è um componente que é usado para mostrar uma descrição de algo
 */

import template from "./data-comparation-value.component.html";
import "./data-comparation-value.component.scss";

class NuDataComparationValue {
    constructor($scope) {
        this.$scope = $scope;
    }
}

NuDataComparationValue.$inject = ["$scope"];

const name = "nuDataComparationValue";
const def = {
    bindings: {
        class: "@",
        serieData: "=",
        nandaInteraction: "="
    },
    controller: NuDataComparationValue,
    controllerAs: "nuDataComparationValue",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
